"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledSettingsComponents = require("./StyledSettingsComponents");

var _Row = _interopRequireDefault(require("./Row"));

var _OrderContext = _interopRequireDefault(require("../context/OrderContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    color: rgb(81, 81, 81);\n    font-size: 11px;\n    transition: all .3s;\n    cursor: pointer;\n    margin-bottom: 3px;\n    display: flex;\n    align-items: center;\n    &:hover {\n        color: #000;\n    }\n    svg {\n        margin-right: 5px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Item = _styledComponents.default.div(_templateObject());

var DoubleUp = function DoubleUp() {
  return _react.default.createElement("svg", {
    width: 15,
    height: 15
  }, _react.default.createElement("g", null, _react.default.createElement("rect", {
    x: 5,
    y: 5,
    width: 9,
    height: 9,
    fill: "white",
    strokeWidth: 1,
    stroke: "black"
  }), _react.default.createElement("rect", {
    x: 3,
    y: 3,
    width: 9,
    height: 9,
    fill: "white",
    strokeWidth: 1,
    stroke: "black"
  }), _react.default.createElement("rect", {
    x: 1,
    y: 1,
    width: 9,
    height: 9,
    fill: "#ababab",
    stroke: "black",
    strokeWidth: 1
  })));
};

var DoubleDown = function DoubleDown() {
  return _react.default.createElement("svg", {
    width: 15,
    height: 15
  }, _react.default.createElement("g", null, _react.default.createElement("rect", {
    x: 5,
    y: 5,
    width: 9,
    height: 9,
    fill: "#ababab",
    strokeWidth: 1,
    stroke: "black"
  }), _react.default.createElement("rect", {
    x: 3,
    y: 3,
    width: 9,
    height: 9,
    fill: "white",
    strokeWidth: 1,
    stroke: "black"
  }), _react.default.createElement("rect", {
    x: 1,
    y: 1,
    width: 9,
    height: 9,
    fill: "white",
    stroke: "black",
    strokeWidth: 1
  })));
};

var Up = function Up() {
  return _react.default.createElement("svg", {
    width: 15,
    height: 15
  }, _react.default.createElement("g", null, _react.default.createElement("rect", {
    x: 5,
    y: 5,
    width: 9,
    height: 9,
    fill: "white",
    strokeWidth: 1,
    stroke: "black"
  }), _react.default.createElement("rect", {
    x: 1,
    y: 1,
    width: 9,
    height: 9,
    fill: "#ababab",
    stroke: "black",
    strokeWidth: 1
  })));
};

var Down = function Down() {
  return _react.default.createElement("svg", {
    width: 15,
    height: 15
  }, _react.default.createElement("g", null, _react.default.createElement("rect", {
    x: 5,
    y: 5,
    width: 9,
    height: 9,
    fill: "#ababab",
    strokeWidth: 1,
    stroke: "black"
  }), _react.default.createElement("rect", {
    x: 1,
    y: 1,
    width: 9,
    height: 9,
    fill: "white",
    stroke: "black",
    strokeWidth: 1
  })));
};

var OrderPanel =
/*#__PURE__*/
function (_Component) {
  _inherits(OrderPanel, _Component);

  function OrderPanel() {
    _classCallCheck(this, OrderPanel);

    return _possibleConstructorReturn(this, _getPrototypeOf(OrderPanel).apply(this, arguments));
  }

  _createClass(OrderPanel, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_StyledSettingsComponents.Panel, null, _react.default.createElement(_OrderContext.default.Consumer, null, function (_ref) {
        var onChangeOrder = _ref.onChangeOrder;
        return _react.default.createElement(_Row.default, {
          label: "\u041F\u043E\u0440\u044F\u0434\u043E\u043A"
        }, _react.default.createElement(Item, {
          onClick: function onClick() {
            return onChangeOrder();
          }
        }, _react.default.createElement(DoubleUp, null), " \u041D\u0430 \u043F\u0435\u0440\u0435\u0434\u043D\u0438\u0439 \u043F\u043B\u0430\u043D"), _react.default.createElement(Item, {
          onClick: function onClick() {
            return onChangeOrder(true);
          }
        }, _react.default.createElement(DoubleDown, null), " \u041D\u0430 \u0437\u0430\u0434\u043D\u0438\u0439 \u043F\u043B\u0430\u043D"), _react.default.createElement(Item, {
          onClick: function onClick() {
            return onChangeOrder(false, true);
          }
        }, _react.default.createElement(Up, null), " \u041F\u0435\u0440\u0435\u043B\u043E\u0436\u0438\u0442\u044C \u0432\u043F\u0435\u0440\u0435\u0434"), _react.default.createElement(Item, {
          onClick: function onClick() {
            return onChangeOrder(true, true);
          }
        }, _react.default.createElement(Down, null), " \u041F\u0435\u0440\u0435\u043B\u043E\u0436\u0438\u0442\u044C \u043D\u0430\u0437\u0430\u0434"));
      }));
    }
  }]);

  return OrderPanel;
}(_react.Component);

exports.default = OrderPanel;